module.exports = __webpack_public_path__ + "assets/2e0b8660b87034ecf56aa9f488fbc08e.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-cyrillic-ext-400-normal.woff2
// module id = 2623
// module chunks = 121